import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree
} from '@angular/router';

import { Account } from '../shared/classes/account';
import { AppConst } from '../shared/constants/app-const';
import { UrlConst } from '../shared/constants/url-const';
import { AccountService } from '../shared/services/account.service';

@Injectable({
  providedIn: 'root',
})
export class SysAdminGuard implements CanActivate {
  constructor(private accountService: AccountService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const user = this.accountService.getUser();

    if (user === null) {
      return this.cantActivate();
    }

    if (this.accountService.groupRank() < AppConst.GROUP_RANK_SYSADMIN) {
      return this.cantActivateCauseGroupRank();
    }
    return true;
  }

  private cantActivate(): boolean {
    this.router.navigate([UrlConst.PATH_SIGN_IN]);
    return false;
  }

  private cantActivateCauseGroupRank(): boolean {
    this.router.navigate([UrlConst.PATH_SIGN_IN]);
    return false;
  }
}
